import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';
import { faqs } from '@/src/constants/FAQs';
import { sendAnalyticsData, trackNavigation } from '@/src/utils/analytics';
import { FAQ } from '../Faqs/FAQ';
import type { IFAQ, IFAQTags } from '../home.interface';
export const SchDistFAQs = t0 => {
  const $ = _c(11);
  const {
    tag
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="py-8 text-center text-[28px] font-medium text-[#000000] md:text-4xl">Frequently Asked Questions</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== tag) {
    t2 = faqs.map((faq, index) => <FAQ key={index} faq={faq} _tag={tag} />);
    $[1] = tag;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="md:mt-6">{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "#ffffff"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link href="/request-quote" onClick={_temp} style={t4} className="mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] p-3 text-base font-medium md:py-2">Get a quote <ChevronRightIcon className="h-5 w-5" /></Link>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mt-10 flex w-[100%] justify-center">{t5}<Link href="/schedule-demo" onClick={_temp2} style={{
        color: "#318AE5"
      }} className="mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium md:py-2">Schedule a Demo</Link></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div>{t6}<div className="mt-2 flex justify-center">or<Link href="/contact-us" onClick={_temp3} style={{
          color: "#318ae5"
        }} className="mx-1 font-semibold">Contact us</Link>for more information.</div></div>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3) {
    t8 = <div className="container mx-auto px-4 pb-16 text-center md:px-16 md:py-20 2xl:px-24">{t1}{t3}{t7}</div>;
    $[9] = t3;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
function _temp() {
  sendAnalyticsData("GET_A_QUOTE_BUTTON_CLICKED_FROM_SCHDIST_FAQS");
  trackNavigation("request-quote", "Get a quote");
}
function _temp2() {
  sendAnalyticsData("SCHEDULE_A_DEMO_BUTTON_CLICKED_FROM_SCHDIST_FAQS");
  trackNavigation("schedule-demo", "Schedule a Demo");
}
function _temp3() {
  sendAnalyticsData("CONTACT_US_BUTTON_CLICKED_FROM_SCHDIST_FAQS");
  trackNavigation("contact-us", "Contact us");
}